import { Pagination, Zone, ZoneIdentifier } from '@ekkogmbh/apisdk';
import { ListItemText } from '@mui/material';
import React, { useCallback } from 'react';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';
import useEkko from 'src/Common/Providers/EkkoProvider';

interface Props {
  selected?: ZoneIdentifier | Zone;
  optional?: boolean;
  onChange: (zone: Zone | undefined) => void;
  disabled?: boolean;
  label?: string;
}

export const ZonePicker = ({ selected, onChange, label, ...props }: Props): React.JSX.Element => {
  const { api } = useEkko();

  const fetchItems = useCallback((pagination: Pagination) => api.getZones(pagination), [api]);

  return (
    <PaginatedSelect
      {...props}
      label={label ?? 'Zone'}
      value={selected as Zone}
      itemId={(z: Zone) => z.coordinate + '::' + z.name}
      itemRender={(z) => <ListItemText primary={z.name} secondary={z.coordinate} />}
      fetchPaginatedItems={fetchItems}
      onChange={(z) => onChange(z as Zone | undefined)}
    />
  );
};
